export { default as IngresosBodega } from "./IngresosBodega";

